import { Pipe, PipeTransform } from '@angular/core';
import sortBy from 'lodash-es/sortBy';
import orderBy from 'lodash-es/orderBy';

@Pipe({
    name: 'sortBy',
    standalone: false
})
export class SortByPipe implements PipeTransform {

  transform(value: any[], order = '', column = ''): any[] {
    if (!value || order === '' || !order) { return value; } // no array
    if (!column || column === '') { return sortBy(value); } // sort 1d array
    if (value.length <= 1) { return value; } // array with only one item
    return orderBy(value, [column], [order]);
  }
}
